module.exports = __webpack_public_path__ + "img/Mehrzweckarbeitsboot.f48a0b0d.svg";